import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchBounces, resendBounce } from "@/api/reportsBounces";
import type { BouncesListParams } from "@/interfaces/reportsBounces";

/** Query key root for the Bounces report list — other units invalidate/prefetch against it. */
export const BOUNCES_QUERY_KEY = ["reports", "bounces"] as const;

/**
 * GET /reports/bounces, keyed by every param so distinct searches/filters/sorts/pages cache
 * independently. `enabled` lets the page hold the request while permissions are still loading.
 */
export function useReportsBounces(params?: BouncesListParams, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [...BOUNCES_QUERY_KEY, "list", params],
    queryFn: () => fetchBounces(params),
    enabled: options?.enabled,
  });
}

/**
 * No `onSuccess` invalidation here: the panel owns both the local `resentIds` override and
 * the query invalidation, since only it can apply them together after a successful resend.
 */
export function useResendBounce() {
  return useMutation({
    mutationFn: ({ contactId, newEmail }: { contactId: number; newEmail: string }) =>
      resendBounce(contactId, { newEmail }),
  });
}
